import type { LDFlagSet } from 'launchdarkly-react-client-sdk';

import type { CamelCaseKeys } from '@/types/generics';

const staticFeatureFlags = {
  FUTURES_FCA_INELIGIBLE_FLOW_ENABLED: false,
  INSTITUTION_INDIVIDUAL_FLOW_SOLE_INDIVIDUAL_ENABLED: true,
  THEME_SELECTOR: false,
} as const satisfies Record<string, boolean>;

type FuturesPublicTradingFlag = {
  enabled: boolean;
};

/** A switch per stage, as dev, staging and preprod share one LaunchDarkly environment */
export type StageFlag = {
  dev: boolean;
  preprod: boolean;
  production: boolean;
  staging: boolean;
};

const ldFeatureFlags = {
  'futures-enabled': false,
  'futures-public-trading': {
    enabled: false,
  } as FuturesPublicTradingFlag,
  'institutional-onboarding-enabled': false,
  'nci-priority-flow-enabled': false,
  'periodic-review': {
    dev: false,
    preprod: false,
    production: false,
    staging: false,
  } as StageFlag,
} satisfies LDFlagSet;

export type LdFeatureFlags = CamelCaseKeys<typeof ldFeatureFlags>;

export { ldFeatureFlags, staticFeatureFlags };
